import { withCompInfo } from '@wix/editor-elements-integrations'
import { ExpandableMenuCSSVars, ExpandableMenuDefinition } from '@wix/thunderbolt-components-native'
import { ExpandableMenuDataProperties } from './ExpandableMenu'

type GridSettings = {
	templateColumns: string
	labelColumns: string
	arrowColumns: string
}

const getGridSettings = (itemsAlignment: ExpandableMenuDataProperties['itemsAlignment']): GridSettings =>
	itemsAlignment === 'center'
		? {
				templateColumns: `calc(40px + 1em) 1fr calc(40px + 1em)`,
				labelColumns: '2',
				arrowColumns: '3',
		  }
		: {
				templateColumns: `1fr calc(40px + 1em)`,
				labelColumns: '1',
				arrowColumns: '2',
		  }

export const css = withCompInfo<ExpandableMenuCSSVars, ExpandableMenuDefinition>()(
	['compProps', 'styleProperties', 'experiments'],
	({ compProps, styleProperties }) => {
		const menuSpacing = styleProperties.menuSpacing
		const subMenuSpacing = styleProperties.subMenuSpacing
		const menuItemHeight = compProps.menuItemHeight
		const itemHeight = `${menuItemHeight === null ? 50 : menuItemHeight}px`
		const itemsAlignment = compProps.itemsAlignment
		const menuArrowDirection = compProps.menuArrowDirection
		const gridSettings = getGridSettings(itemsAlignment)

		const paddingLeft = itemsAlignment === 'left' ? menuSpacing : '0px'
		const subPaddingLeft = itemsAlignment === 'left' ? subMenuSpacing : '0px'
		const paddingRight = itemsAlignment === 'right' ? menuSpacing : '0px'
		const subPaddingRight = itemsAlignment === 'right' ? subMenuSpacing : '0px'

		return {
			height: 'auto',
			'--direction': menuArrowDirection === 'right' ? ('ltr' as const) : ('rtl' as const),
			'--item-height': itemHeight,
			'--text-align': itemsAlignment,
			'--template-columns': gridSettings.templateColumns,
			'--label-grid-column': gridSettings.labelColumns,
			'--arrow-grid-column': gridSettings.arrowColumns,
			'--padding-left': paddingLeft,
			'--sub-padding-left': subPaddingLeft,
			'--padding-right': paddingRight,
			'--sub-padding-right': subPaddingRight,
		}
	}
)
